export const TABLE_HEAD = classes => {
  return [
    {
      label: 'Name',
      align: 'left',
      cellClassName: classes.nameCell
    },
    {
      label: 'Email',
      cellClassName: classes.emailCell,
      align: 'left'
    },
    {
      label: 'Phone',
      cellClassName: classes.unitCell,
      align: 'left'
    },
    {
      label: 'Email notification',
      cellClassName: classes.unitCell,
      align: 'left'
    },
    { label: 'Actions', align: 'right' }
  ];
};
